import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {config } from "../../api/config.js";
import {message } from "antd";

const apiUrl = process.env.REACT_APP_URL;


export const userLogin = createAsyncThunk(
  "aut/user/login",
  async (user, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.post(`${apiUrl}/auth/user/login`, user);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
export const userRegister = createAsyncThunk(
  "auth/user/register",
  async (user, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.post(`${apiUrl}/auth/user/register`,user,config);
      if (res.status === 201) {
        return res.data.user;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
export const loginedUser = createAsyncThunk("auth/user", async (_, thunkApi) => {
  const { rejectWithValue } = thunkApi;
  try {
    const res = await axios.get(`${apiUrl}/auth/user`,config);
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    message.error(error.response.data.msg, 3);
    localStorage.removeItem("cardsToken");
    return rejectWithValue(error.response.data.msg);
  }
});


